export const environment = {
  enableTIIIStateAdminDelete: false,
  production: true,
  enableRepairRowsButton: true,
  disableAdalNonceCheck: false,
  nonceWhitelist: [],
  env: 'ENV_REPLACE_TOKEN-DAFUpXkpyP',
  forgotPwdLink: 'https://portal.acl.gov',
  oktaConfig: {
    issuer: 'https://portal.acl.gov/oauth2/aus5hp8fcxk5EMjf2297',
    url: 'https://portal.acl.gov/',
    clientId: '0oa9n6pyjkOMZ8HJB297',
    redirectUri: `${window.location.origin}/jwt`,
    responseMode: 'fragment',
    pkce: false,
    implicitFlowConfig: {
      redirectUri: `${window.location.origin}/jwt`,
      postLogoutRedirectUri: `${window.location.origin}/`,
    },
  }
};

